'use client';
'use strict';

var classes = {"root":"m-5ae2e3c","barsLoader":"m-7a2bd4cd","bar":"m-870bb79","bars-loader-animation":"m-5d2b3b9d","dotsLoader":"m-4e3f22d7","dot":"m-870c4af","loader-dots-animation":"m-aac34a1","ovalLoader":"m-b34414df","oval-loader-animation":"m-f8e89c4b"};

module.exports = classes;
//# sourceMappingURL=Loader.module.css.cjs.map
